import UpdateCollectionImageModalForm from './UpdateCollectionImageModalForm';



export default UpdateCollectionImageModalForm;
